import { render, staticRenderFns } from "./GroupNews.vue?vue&type=template&id=ea1aff00&scoped=true"
import script from "./GroupNews.vue?vue&type=script&lang=js"
export * from "./GroupNews.vue?vue&type=script&lang=js"
import style0 from "./GroupNews.vue?vue&type=style&index=0&id=ea1aff00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea1aff00",
  null
  
)

export default component.exports